export const JWT_TOKEN_COGNITO = 'tokenJwt_appai';
export const JWT_TOKEN_COGNITO_ID = 'idTokenJwt_appai';
